module.exports = __webpack_public_path__ + "static/media/commentLikeBtn.06c57363.svg";